/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { throwError$ } from '@gh/rx';
import { catchError$ } from '@gh/rx/operators';
import { Observable, ObservableInput } from 'rxjs';
import { isMessageBasket, MessageBasket } from './message-basket';

export function catchErrors<T, R>(...handlers: [
  string,
  TransformFn<MessageBasket, ObservableInput<R>>][]): (ob: Observable<T>) => Observable<R> {

  return <any>((ob: Observable<T>) => ob.pipe(catchError$<T, any>((error: any) => {
    if (!isMessageBasket(error)) {
      return throwError$(error);
    }
    const handler = handlers.find(([messageId]) => error.has(messageId));
    return (handler ? handler[1](error) : throwError$(error));
  })));
}
